import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Container, Row, Col, Input, Spinner, Fade } from "reactstrap";
import { clientTypeConstants } from "../../constants/clientType.constants";
import { HubConnectionBuilder } from "@aspnet/signalr";
import { cmsActions } from "../../../store/actions/cms/cms.action";
import { sourceTypes } from "../../../constants/cms/sourceType";
import Axios from "axios";
import "../style/StageStyle.css";
import { questionActions } from "../../../store/actions/question/question.action";
import QuetsionAnswerView from "../components/QuestionAnswerView";
import { getKey } from "../../../helpers/UrlHelper";
import { ConnectionStatus } from "../../../digitalArena/components/fallbacks/ConnectionStatus";
import { Loader } from "../../../digitalArena/utils/ClientConnectionFallback";

class StageLayout extends Component {
  state = {
    hubConnection: null,
    clientKey: "",
    eventName: "xx",
    answer: null,
    question: null,
    availableLanguages: null,
    clientResponses: [],
    defaultLanguage: "swe",
    selectedLanguage: null,
    connecting: true,
    connected: false,
    eventId: -1,
    templateId: 0,
    countdown: 0,
    responses: [],
    init: false,
    activeQuestions: [],
    connectionList: [],
  };
  componentDidMount() {
    window.scrollTo(0, 0);
    const eventId = this.props.match.params.id;
    document.body.style.overflow = "hidden";
    if (isNaN(eventId)) {
      this.getEventId(eventId);
    } else {
      this.props.dispatch(questionActions.getAllQuestionsByEvent(eventId));
      this.setState({ eventId }, () => this.connectToHub());
    }
    const params = new URLSearchParams(this.props.location.search);
    const lang = params.get(getKey("lang", params));
    if (lang) this.setState({ defaultLanguage: lang });
    // this.props.dispatch(templateActions.getDefaultTemplateByEvent(eventId));
    this.props.dispatch(cmsActions.setEnviroment(sourceTypes.INTERACTION, false));
  }
  componentDidUpdate(prevProps, prevState) {
    const { connecting, dismissConnectionLoss, forceDisc, connected } = this.state;

    if (connected == false && prevState.connected == true && connecting == false) {
      this.tryReconnect();
      this.counter = setInterval(() => this.setState({ countdown: this.state.countdown + 1 }), 1000);
    } else if (this.state.countdown >= 60 && !connected && prevState.connected == false) {
      this.setState({ countdown: 0, connecting: false });
      this.tryReconnect();
    } else if ((connected == true || (this.hubConnection && this.hubConnection.connectionState == 1)) && prevState.connected == false && !this.state.connecting && this.hubConnection && this.hubConnection.connectionState == 1) {
      if (this.counter) clearInterval(this.counter);
      this.setState({ countdown: 0 });
    }
  }
  getEventId = (eventCode) => {
    Axios.get(`./api/event/getId/${eventCode}`)
      .then((res) => {
        this.setState({ eventId: res.data.id, eventName: res.data.name }, () => this.connectToHub());
        this.props.dispatch(questionActions.getAllQuestionsByEvent(res.data.id));
        document.title = "Stage - " + res.data.name;
      })
      .catch((err) => {
        console.error(err);
      });
  };
  tryReconnect = () => {
    if (!this.state.connected && !this.state.connecting) {
      this.setState({ connecting: true }, this.connectToHub());
    }
  };
  setClientKey = (key) => {
    localStorage.setItem("CLIENT_KEY", key);
  };
  getClientKey = () => {
    return localStorage.getItem("CLIENT_KEY") || null;
  };
  onGetActiveQuestions = (qList) => {
    if (qList.length > 0) {
      let questionIds = qList.map((ql) => {
        return ql.question.questionId;
      });
      this.setState({ activeQuestions: questionIds });
    }
  };
  connectToHub = () => {
    const { eventId } = this.state;
    const { user } = this.props;
    try {
      if (!this.hubConnection) {
        this.hubConnection = new HubConnectionBuilder().withUrl("./ihub").build();
      }
    } catch (error) {}
    let clientKey = this.getClientKey();
    this.hubConnection
      .start()
      .then(() => {
        this.hubConnection.on("onHandshake", this.onHandshake);
        this.hubConnection.on("onClientResponse", this.onClientResponse);

        this.hubConnection.on("onClearEventData", () => this.setState({ clientResponses: [], speakers: [] }));
        this.hubConnection.on("onToggleQuestionInfo", this.onToggleQuestionInfo);
        this.hubConnection.on("onToggleQuestion", this.onToggleQuestion);
        this.hubConnection.on("onGetActiveQuestions", this.onGetActiveQuestions);
        this.hubConnection.on("onStatusChanged", this.onStatusChanged);
        this.hubConnection.on("onClearQuestionAnswers", this.onClearQuestionAnswers);
        this.hubConnection.on("onNewConnection", this.onNewConnection);
        this.hubConnection.on("onNewDisconnection", this.onNewDisconnection);
        this.hubConnection.on("onClearResponses", this.onClearResponses);
        this.hubConnection.onclose(this.onClose);

        this.hubConnection.on("onGetActiveConnections", (connectionList) => {
          let cL = connectionList.filter((cl) => cl.type == clientTypeConstants.INTERACTION_MEETING);
          this.setState({ connectionList: cL });
        });
        this.hubConnection.invoke("getActiveConnections", eventId, null, null);
        this.hubConnection
          .invoke("handshake", {
            eventId,
            clientType: clientTypeConstants.INTERACTION_STAGE,
            clientKey,
            userGuid: user ? user.userGuid : null,
          })
          .catch((err) => {
            console.error(err);
          });
      })
      .catch((error) => {});
  };
  onStatusChanged = (id, type) => {
    let changedAnswer = this.state.clientResponses.find((r) => r.answerId == id);
    if (changedAnswer) {
      const newResponseList = Array.from(this.state.clientResponses);
      let index = this.state.clientResponses.indexOf(changedAnswer);
      if (index > -1) {
        newResponseList[index].stageStatus = type;
        this.setState({ clientResponses: newResponseList });
      }
    }
  };
  onNewConnection = (conn) => {
    if (conn.type == "INTERACTION_MEETING") {
      let cL = this.state.connectionList.filter((c) => !(c.clientKey == conn.clientKey && c.type == conn.type));
      cL.push(conn);
      this.setState({ connectionList: cL });
    }
  };
  onNewDisconnection = (connectionId) => {
    if (this.state.connectionList.find((c) => c.connectionId == connectionId)) {
      let cL = this.state.connectionList.filter((c) => c.connectionId != connectionId);
      this.setState({ connectionList: cL });
    }
  };
  onClearQuestionAnswers = (res) => {
    if (res) {
      let uptResponses = Array.from(this.state.clientResponses);
      uptResponses = uptResponses.filter((r) => r.questionId !== res);
      this.setState({ clientResponses: uptResponses });
    }
  };
  onClose = () => {
    this.setState({ connected: false });
    if (!window.location.hostname.includes("localhost")) {
      this.connectToHub();
    }
  };
  onClearResponses = () => {
    this.setState({ clientResponses: [] });
  };

  onHandshake = (response) => {
    if (response.success) {
      this.setState({ connected: true, connecting:false, init: true });
    } else {
    }
  };

  convertOptionIdToText = (id) => {
    let optionId = parseInt(id);
    if (isNaN(optionId)) return id;
    const { question, defaultLanguage } = this.state;
    let text = id;
    try {
      text = question.questionOption.find((o) => o.questionOptionId === optionId).questionOptionLanguage.find((l) => l.languageCode === defaultLanguage).label;
    } catch (error) {}
    return text;
  };

  setStageStatus = (id, type) => {
    this.hubConnection.invoke("setStageStatus", id, type, this.state.eventId).catch((err) => {
      console.error(err);
    });
  };
  onClientResponse = (response) => {
    const responses = Array.from(this.state.clientResponses);
    const existingResponse = responses.find((r) => {
      return r.answerId === response.answerId;
    });
    if (existingResponse) {
      let indexOf = responses.indexOf(responses.find((r) => r.answerId === response.answerId));
      if (indexOf > -1) {
        responses[indexOf].status = response.status;
      }
    } else if (response.type === "Option") {
      response.answerText = this.convertOptionIdToText(response.answer, response.questionId);
    }
    if (!existingResponse) {
      responses.push(response);
    }
    this.setState({ clientResponses: responses });
  };

  toggleQuestionInfo = (question) => {
    this.hubConnection.invoke("toggleQuestionInfo", question.questionId, question.eventId, question.type, false);
  };
  onToggleQuestionInfo = (response) => {
    this.setState({ clientResponses: response.clientResponses });
  };
  onToggleQuestion = (response) => {
    let newList = Array.from(this.state.activeQuestions);
    if (response.active) {
      newList.push(response.questionId);
    } else {
      newList = newList.filter((q) => q !== response.questionId);
    }
    this.setState({ activeQuestions: newList });
  };
  groupTemplate = () => {
    const { template } = this.props;
    if (template === undefined) return null;
    return template.content;
  };

  render() {
    const { connected, init, activeQuestions, clientResponses } = this.state;
    const { template, questions } = this.props;
    const style = this.groupTemplate();
    const connectionsProps = { hubConnection: this.hubConnection, ...this.state };
    if(!init) return <Loader />
    return (
      <React.Fragment>
        <ConnectionStatus {...connectionsProps} hubConnection={this.hubConnection} />
        <QuetsionAnswerView
          lang={this.state.defaultLanguage}
          questions={questions}
          activeQuestions={activeQuestions}
          responses={clientResponses}
          setStageStatus={this.setStageStatus}
          toggleQuestionInfo={this.toggleQuestionInfo}
          eventName={this.state.eventName}
          connectionList={this.state.connectionList}
        />
      </React.Fragment>
    );
  }
}
function mapStateToProps(state) {
  return {
    template: state.template.template,
    questions: state.question.questions,
    user: state.authentication.user,
  };
}
export default connect(mapStateToProps)(StageLayout);
